import { Eye, HandHeart, Sparkles, BookOpen, ArrowRight } from "lucide-react";

const ITEMS = [
  { name: "Spiritual Readings", icon: Eye, text: "Intuitive readings that bring clarity to your path, your purpose and the messages your spirit is ready to receive." },
  { name: "Energy Healing", icon: HandHeart, text: "Gentle healing sessions that release heavy energy, restore balance and help you turn old wounds into new light." },
  { name: "Starseed Guidance", icon: Sparkles, text: "Guidance for starseeds and sensitive souls to remember who they are, where they come from and why they are here." },
  { name: "Teaching / Classes", icon: BookOpen, text: "Classes for individuals, parents and families to grow their gifts, protect their energy and walk in their calling." },
];

const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-");

export const Services = ({ onRequest }) => (
  <section id="services" data-testid="services-section" className="px-6 md:px-16 py-24 md:py-32">
    <div className="max-w-2xl">
      <p className="eyebrow">Sacred offerings</p>
      <h2 className="font-display gold-text text-4xl md:text-5xl mt-3">Services</h2>
      <p className="mt-5 text-base md:text-lg text-[#f7f1e1]/80">Choose the support your spirit is calling for. Each session is held with love, care and divine guidance.</p>
    </div>
    <div className="grid sm:grid-cols-2 gap-6 md:gap-8 mt-14">
      {ITEMS.map(({ name, icon: Icon, text }, i) => (
        <div key={name} className={i % 2 ? "sm:mt-12" : ""}>
          <div className="glass card-hover rounded-[1.5rem] p-8 md:p-9 h-full flex flex-col" data-testid={`service-card-${slug(name)}`}>
            <div className="w-14 h-14 rounded-full border border-[#d4af37]/50 flex items-center justify-center text-gold mb-6"><Icon size={20} strokeWidth={1.5} /></div>
            <h3 className="font-cinzel text-2xl text-[#f1d57a]">{name}</h3>
            <p className="mt-4 text-[#f7f1e1]/75 leading-relaxed flex-1">{text}</p>
            <button onClick={() => onRequest(name)} data-testid={`service-request-${slug(name)}`} className="mt-10 self-start inline-flex items-center gap-2 font-cinzel text-xs tracking-[0.2em] uppercase text-gold group">
              Request this <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      ))}
    </div>
  </section>
);
